import { Spacer } from "../atoms/Atoms"
import React, { FC, ReactNode } from "react"
import { Progress } from "components/views/modal/Progress"

type TopSectionProps = {
  progressStep: number
  leftOrBackArrow: ReactNode
}

const TopSection: FC<TopSectionProps> = ({ progressStep, leftOrBackArrow }) => {
  const progressLabel =
    progressStep === 1
      ? "Create your account"
      : progressStep === 2
      ? "About you"
      : progressStep === 3
      ? "About your partner"
      : "Your journey"
  return (
    <>
      <Progress label={progressLabel} step={progressStep} />
      {leftOrBackArrow}
      <Spacer height={3} />
    </>
  )
}
export { TopSection }
